import styled from "styled-components";
import { Container } from "../../theme/styles";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import bannerSrc from '../../assets/images/banner-home.jpeg';
import { getArtigos, getTitulos, useLDA } from "../../hooks/useLDA";
import { Collapse } from "../../components/Collapse";
import { Collapse as LocalCollapse } from "./components/v2/Collapse";
import { generatePDF } from "./generate";
import { useLocation } from "react-router-dom";
import { useRef, useState } from "react";
import { getComments, useComments, Response } from "../../hooks/useLdaComments";


function LDAResult() {
  let { title, article, text }: any = useLDA()
  const titulos = getTitulos();
  const [results, setResult] = useState<Response|null>(null);
  const location: any = useLocation();
  
  const [data, setData] = useState({
    artigo: location?.state?.data?.artigo && typeof location?.state?.data?.artigo === 'string'? JSON.parse(location?.state?.data?.artigo) : {},
    paragrafo: location?.state?.data?.paragrafo && typeof location?.state?.data?.paragrafo === 'string'? JSON.parse(location?.state?.data?.paragrafo) : {},
    inciso: location?.state?.data?.inciso && typeof location?.state?.data?.inciso === 'string'? JSON.parse(location?.state?.data?.inciso) : {},
    alinea: location?.state?.data?.alinea && typeof location?.state?.data?.alinea === 'string'? JSON.parse(location?.state?.data?.alinea) : {}
  });

  // const data = {
  //   artigo: location?.state?.data?.artigo, 
  //   paragrafo: location?.state?.data?.paragrafo, 
  //   inciso: location?.state?.data?.inciso,
  //   alinea: location?.state?.data?.alinea,
  // };

  // try {
  //   setData({
  //     artigo: data?.artigo && typeof data.artigo === 'string'? JSON.parse(data.artigo) : {},
  //     paragrafo: data?.paragrafo && typeof data.paragrafo === 'string'? JSON.parse(data.paragrafo) : {},
  //     inciso: data?.inciso && typeof data.inciso === 'string'? JSON.parse(data.inciso) : {},
  //     alinea: data?.alinea && typeof data.alinea === 'string'? JSON.parse(data.alinea) : {}
  //   })
  // } catch (error) {}

  // const [artigo, setArtigo] = useState(data.artigo);
  const [selected, setSelected] = useState({
    'Parágrafo': data.paragrafo,
    'Inciso': data.inciso,
    'Alínea': data.alinea,
  });

  function formatSearch(): string[] {
    let paths = Object.values(selected).reduce((prev, val ) => {
      if(!val?.history) return prev;
      prev.push(`${val?.history}`)
      return prev
    }, []);

    if(!paths?.length) {
      paths = [`${data?.artigo?.history}`]
    }
    console.log(paths);
    return paths
  }
  const [search, setSearch] = useState(formatSearch());
  const { legislative, jurisprudence, doctrinal, comments } = useComments({ paths: search });

  function validateBody (value: any){
    return value && !value?.length && typeof value === 'object'
  }

  function formatBody (key: any, value: any){
    return `${`${key}`.replace('_val', '')} - ${`${value.text}`.replace('_val', '')}`
  }

  function isSelected (key: any, value: any, history: string = ''){
    const typeSelect = (selected as any)[value.type];
    return `${history}#${key}` === typeSelect.history
  }
  function toBody(artigo:any, history: string = '') {
    let text = '';
    Object.entries(artigo).map(([key, value]: any) => {
      if(validateBody(value)) {
        let body = formatBody(key, value)
        if(isSelected(key, value, history)) {
          body = `<strong>${body}</strong>`
        }
        text += body;
        text += '<br /><br />'
        text += toBody(value, `${history}#${key}`);
      }
      return text;
    });
    return text;
  }

  function shrinkBody(text: string) {
    const shrink: string[] = []
    let lastSelectIndex = 0;
    const splited = text.split('<br /><br />');
    if (splited.length <= 4) return '';
    splited.map((value: string, i, array) => {
      if(value.indexOf('<strong>') === 0 && value.includes('</strong>')) {
        if(lastSelectIndex && (i - lastSelectIndex) > 2){
          shrink.push('...');
        }
        const before_value = array[i-1] || '';
        if(!shrink.length || (before_value && before_value !== shrink[shrink.length-1])) {
          shrink.push(before_value)
        }
        shrink.push(value);
        lastSelectIndex = i +1;

        const after_value = array[i+1] || '';
        if(after_value.indexOf('<strong>') !== 0 || !after_value.includes('</strong>')){
          shrink.push(after_value);
        }
      }
      return value;
    });
    if(!shrink.length) {
      shrink.push(splited?.[0] || '');
      if (splited?.[1])
        shrink.push(splited?.[1] || '');
      if (splited?.[2])
        shrink.push(splited?.[2] || '');
    }
    return shrink.join('<br /><br />');
  }

  let article_text = '';
  let shrinkText = '';
  if (data.artigo) {
    title = `Título ${data.artigo['Título']} <br /> ${((titulos as any)[data.artigo['Título']].text) as any}`;
    article = data.artigo?.history?.split('#').join('');
    text = toBody(data.artigo, '#'+article);
    shrinkText = shrinkBody(text);
    //article = `${article}`.replace('_val', '')
    article_text = `${data.artigo?.text}`.replace('_val', '');
  }
 
  // ugly but worked, delay api call and cancel when change fast
  const timer1 = useRef(setTimeout(() => {}, 1));
  async function forceGetComments(history: string) {
    clearTimeout(timer1.current);
    timer1.current = setTimeout(async () => 
      (setResult(await getComments( { paths: [ history ] } )))
    , 1000);
  } 

  const nextArticle = Object.entries(getArtigos()).find(([key, value]: any, i, array) => {
    if(i) {
      const previous = array?.[i-1]?.[0];
      if(previous === article){
        value['history'] = `#${key}#`;
        return true;
      }
    }
    return false;
  });
  const previousArticle = Object.entries(getArtigos()).find(([key, value]: any, i, array) => {
    if(i < array.length - 1) {
      const next = array?.[i+1]?.[0]
      if(next === article){
        value['history'] = `#${key}#`;
        return true;
      }
    }
    return false;
  });

  article = `${article}`.replace('_val', '')
  async function next() {
    if (!nextArticle) return;
    setData({
      artigo: nextArticle[1],
      alinea: {},
      inciso: {},
      paragrafo: {}
    })
    setSelected({
      Alínea: {},
      Inciso: {},
      Parágrafo: {}
    })
    await forceGetComments((nextArticle[1] as any)?.history);
  }
  async function previous() {
    if (!previousArticle) return;
    clearTimeout(timer1.current);
    setData({
      artigo: previousArticle[1],
      alinea: {},
      inciso: {},
      paragrafo: {}
    })
    setSelected({
      Alínea: {},
      Inciso: {},
      Parágrafo: {}
    })
    await forceGetComments((previousArticle[1] as any)?.history);
  }

  function haveSelected() {
    if(location?.state?.data?.artigo !== JSON.stringify(data.artigo)) return false;
    if(Object.values(selected).some((value) => Object.keys(value).length)) return true;
    const rawData = location?.state?.data;
    if(!rawData?.paragrafo && !rawData?.inciso && !rawData?.alinea) return false;
    try {
      const selec = {
        paragrafo: rawData?.paragrafo && typeof rawData?.paragrafo === 'string'? JSON.parse(rawData?.paragrafo) : {},
        inciso: rawData?.inciso && typeof rawData?.inciso === 'string'? JSON.parse(rawData?.inciso) : {},
        alinea: rawData?.alinea && typeof rawData?.alinea === 'string'? JSON.parse(rawData?.alinea) : {}
      }
      const result = Object.values(selec).some((value) => Object.keys(value).length);
      if(!result) return result;
      setData({
        artigo: data.artigo,
        ...selec
      });
      setSelected({
        Alínea: selec.alinea,
        Inciso: selec.inciso,
        Parágrafo: selec.paragrafo
      })
    } catch (error) {}
    return false
  }
  function formatDate(date: string) {
    if (!date) return '';

    const d = date.split('-'); // yyyy-mm-dd
    return `${d[2]}/${d[1]}/${d[0]}`
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} title="IBDAutoral" />
      <Container isSmall>
        <Content>
          <Title>LDA Comentada</Title>
          <Subtitle dangerouslySetInnerHTML={{ __html: title }} />
          <ArrowsBox>
            <ArrowDiv isLeft={true}>
              <Arrow onClick={() => previous()} hide={!previousArticle}>&#9666;</Arrow>
            </ArrowDiv>
            <Article justMobile={false}>
              <ArticleNumber>Art. {article}</ArticleNumber>
              <ArticleText>{ article_text }</ArticleText>
            </Article>
            <ArrowDiv isLeft={false}>
              <Arrow onClick={() => next()} hide={!nextArticle}>&#9656;</Arrow>
            </ArrowDiv>
          </ArrowsBox>
          <Article justMobile={true}>
            <ArticleNumber>Art. {article}</ArticleNumber>
            <ArticleText>{ article_text }</ArticleText>
          </Article>
          <TextContent>
            {(shrinkText && text) &&
            <LocalCollapse isFirst={!haveSelected()}>
              <Text dangerouslySetInnerHTML={{ __html: shrinkText }} />
              <Text dangerouslySetInnerHTML={{ __html: text }} />
            </LocalCollapse>
            }
            {(!shrinkText && text) &&            
              <Text dangerouslySetInnerHTML={{ __html: text }} />
            }
          </TextContent>
          {(
            (results?.legislative || legislative) || 
            (results?.jurisprudence || jurisprudence) || 
            (results?.doctrinal || doctrinal)
          ) && 
          <References>
            <ReferencesTitle>Referências</ReferencesTitle>
            {(!!(results?.legislative || legislative)) && 
            <Collapse background="#f7f7f7">
              <span>Legislativas</span>
              <div dangerouslySetInnerHTML={{ __html: `${(results?.legislative || legislative)?.body}` }} />
            </Collapse>
            }
            {(!!(results?.jurisprudence || jurisprudence)) && 
            <Collapse>
              <span>Jurisprudências</span>
              <div dangerouslySetInnerHTML={{ __html: `${(results?.jurisprudence || jurisprudence)?.body}` }} />
            </Collapse>
            }
            {(!!(results?.doctrinal || doctrinal)) && 
            <Collapse background="#f7f7f7">
              <span>Doutrinárias</span>
              <div dangerouslySetInnerHTML={{ __html: `${(results?.doctrinal || doctrinal)?.body}` }} />
            </Collapse>
            }
          </References>
          }
          <Comments>
            {(results?.comments || comments).map((comment: any) => (
              <Comment key={comment.id}>
                <CommentTitle>Comentário</CommentTitle>
                <CommentName>{comment.user}</CommentName>
                <CommentInstitution>{comment.institution}</CommentInstitution>
                <CommentDate>{formatDate(comment.date)}</CommentDate>
                <CommentText>{comment.body}</CommentText>
              </Comment>
            ))}
          </Comments>
        </Content>
        <GeneratePdfButton
          onClick={() => generatePDF({ 
            title, 
            article, 
            article_text, 
            text, 
            legislative: (results?.legislative || legislative)? `${(results?.legislative || legislative)?.body}` : '', 
            jurisprudence: (results?.jurisprudence || jurisprudence)? `${(results?.jurisprudence || jurisprudence)?.body}` : '',
            doctrinal: (results?.doctrinal || doctrinal)? `${(results?.doctrinal || doctrinal)?.body}` : '',
            comments: (results?.comments || comments)
          })}
        >
          Gerar PDF
        </GeneratePdfButton>
      </Container>
      <Footer />
    </>
  );
}

export default LDAResult;

const Content = styled.div`
  display: flex;
  padding: 0;
  margin-top: -46px;
  z-index: 1;
  position: relative;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.span`
  display: inline-block;
  font-size: 48px;
  padding: 16px 42px;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: ${({ theme }) => theme.colors.orange.medium};
  margin: 0 auto 32px;
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    padding: 12px 32px;
  }
`;

const Subtitle = styled.span`
  font-family: 'Coolvetica Condensed';
  display: block;
  max-width: 440px;
  font-size: 56px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.blue.dark};
  text-align: center;
  margin: 0 auto 64px;
  text-decoration: underline;
  text-decoration: underline;
  text-decoration-thickness: 3px;
  text-underline-offset: 10px;
  line-height: 1.2;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    margin: 0 0 20px;
    text-align: left;
  }
`;

const Article = styled.div<{ justMobile: boolean }>`
  border: 3px solid ${({ theme }) => theme.colors.blue.dark};
  border-radius: 12px;
  margin: 0px 10px;
  padding: 38px 42px 28px;
  position: relative;
  margin-bottom: 32px;
  display: ${({ justMobile }) => (justMobile ? 'none' : 'block')};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    padding: 24px 16px;
    display: ${({ justMobile }) => (justMobile ? 'block' : 'none')};
  }
`;

const ArticleNumber = styled.span`
  font-size: 56px;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: #fff;
  padding: 0 8px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -55%);

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    left: 0;
    padding: 0 4px;
    transform: translate(4px, -55%);
  }
`;

const ArticleText = styled.span`
  display: block;
  font-size: 32px;
  color: ${({ theme }) => theme.colors.blue.dark};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 20px;
  }
`;

const TextContent = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin-left: -14px;
    margin-right: -14px;
    background: #f7f7f7;
    padding: 20px 14px 6px;
  }
`;

const Text = styled.p`
  font-size: 24px;
  line-height: 1.4;
  margin-bottom: 32px;
  color: ${({ theme }) => theme.colors.black.dark};
  font-family: Raleway;
  font-weight: 400;

  strong {
    background-color: ${({ theme }) => theme.colors.blue.dark};
    color: #fff;
    font-family: Raleway;
    font-weight: bold;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 18px;
    padding: 0 12px;
    margin-bottom: 16px;
  }
`;

const References = styled.div`
  display: flex;
  padding: 0;
  position: relative;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 32px;
`;

const ReferencesTitle = styled.span`
  display: inline-block;
  font-size: 42px;
  padding: 6px 32px;
  color: ${({ theme }) => theme.colors.orange.medium};
  background-color: ${({ theme }) => theme.colors.blue.dark};
  margin: 64px auto;
  text-align: center;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 32px;
    padding: 6px 20px;
    margin: 42px auto 20px;
  }
`;

const Comments = styled.div`
  margin: 32px 16px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin: 0;
  }
`;

const Comment = styled.div`
  border: 3px solid ${({ theme }) => theme.colors.blue.dark};
  border-radius: 12px;
  margin: auto;
  padding: 32px 58px 24px 24px;
  position: relative;
  margin-bottom: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: 100%;
    padding: 24px 16px;
  }

  &::before {
    content: '';
    background-image: url('/comment-icon.png');
    width: 70px;
    height: 70px;
    background-size: contain;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(35%, -35%);

    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      width: 40px;
      height: 40px;
    }
  }
`;

const CommentTitle = styled.span`
  font-size: 36px;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: #fff;
  padding: 0 8px;
  position: absolute;
  top: 0;
  left: 16px;
  transform: translateY(-50%);

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 24px;
    left: 8px;
    padding: 0 4px;
  }
`;

const CommentName = styled.span`
  display: block;
  font-size: 38px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: #fff;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 26px;
    line-height: 1.2;
    width: calc(100% - 100px);
  }
`;

const CommentInstitution = styled.span`
  display: block;
  font-family: 'Coolvetica Condensed';
  font-size: 36px;
  line-height: 0.8;
  color: ${({ theme }) => theme.colors.blue.dark};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 26px;
    line-height: 1;
  }
`;

const CommentDate = styled.span`
  display: inline-block;
  position: absolute;
  font-family: 'Coolvetica Condensed';
  top: 32px;
  right: 58px;
  background-color: ${({ theme }) => theme.colors.blue.dark};
  color: #fff;
  padding: 2px 16px;
  font-size: 34px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 22px;
    top: 30px;
    right: 20px;
    padding: 2px 8px;
  }
`;

const CommentText = styled.p`
  font-size: 26px;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.gray.darker};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 18px;
  }
`;

const GeneratePdfButton = styled.button`
  display: block;
  font-size: 40px;
  padding: 24px 120px 24px 42px;
  color: ${({ theme }) => theme.colors.blue.dark};
  background-color: ${({ theme }) => theme.colors.orange.medium};
  margin: 0 auto 64px;
  text-align: center;
  border: none;
  border-radius: 8px;
  position: relative;
  cursor: pointer;

  &::before {
    content: '';
    background-image: url('/pdf-icon.png');
    width: 58px;
    height: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    right: 32px;
    transform: translateY(-50%);

    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      width: 38px;
      height: 46px;
      right: 26px;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 28px;
    padding: 16px 80px 16px 24px;
  }
`;

const Arrow = styled.span<{ hide?: boolean }>`
  display: inline-block;
  font-size: 42px;
  padding: 6px 12px 12px;
  background-color: ${({ hide, theme }) => (hide ? '#fff0' : theme.colors.blue.dark)};
  color: ${({ hide, theme }) => (hide ? '#fff0' : theme.colors.orange.medium)};

  text-align: center;
  cursor: ${({ hide }) => (hide ? 'auto' : 'pointer')};

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    font-size: 24px;
    padding: 0px 50px;
  }
`;

const ArrowDiv = styled.div<{ isLeft: boolean }>`
  display: flex;
  //cursor: pointer;
  flex: 1;
  align-items: flex-start;
  justify-content: ${({ isLeft }) => (isLeft ? 'flex-start' : 'flex-end')};
  padding: 30px 0px;
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0px;
  }
`;

const ArrowsBox = styled.div`
  display: flex;
  padding: 0;
  position: relative;
  justify-content: center;
  flex-direction: row;
  margin-bottom: 32px;
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    margin-bottom: 20px;
  }
`;
